import { useI18n } from '@/i18n';

/**
 * ONE consistent confirmation component for the whole app — every
 * destructive or external action routes through this, never a raw
 * browser confirm()/alert(). Per the brief: state what will happen, which
 * record, and whether it's reversible.
 */
export function ConfirmModal({
  open,
  title,
  recordName,
  description,
  reversible,
  tone = 'normal',
  confirmLabel,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  title: string;
  recordName?: string;
  description: string;
  reversible?: boolean;
  tone?: 'normal' | 'destructive';
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const { t } = useI18n();
  if (!open) return null;
  return (
    <div className="drawer-backdrop" style={{ zIndex: 70, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={onCancel}>
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>{title}</div>
        {recordName && <div style={{ fontSize: 13, color: 'var(--text-2)', marginBottom: 8 }}>{recordName}</div>}
        <div style={{ fontSize: 13, color: 'var(--text-2)', marginBottom: 6 }}>{description}</div>
        {reversible === false && <div style={{ fontSize: 12, color: 'var(--crit)', marginBottom: 14 }}>This cannot be undone.</div>}
        {reversible === true && <div style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 14 }}>This can be reversed later.</div>}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onCancel}>{t('common.cancel')}</button>
          <button className={tone === 'destructive' ? 'btn-danger' : 'btn-primary'} onClick={onConfirm}>
            {confirmLabel ?? t('common.save')}
          </button>
        </div>
      </div>
    </div>
  );
}
